module.exports = __webpack_public_path__ + "img/18.b4d143a6.jpg";